<template>
    <div class="base-info">
        <div v-if="detailObj.length > 0" >
            <div v-for="(item, index) in detailObj" :key="'base-info' + index" :index="index">
                <div v-if="item.type == 3"  >
                    <div class="goods-count" @click="videoPlayFun(index, item.id)" v-if="!item.isPlay">
                        <img :src="item.url" class="swipe-img " />
                        <div class="play-icon">
                            <img class="play-img" src="@/assets/play.png" alt="">
                        </div>
                    </div>
                    <div class="goods-count" v-else>
                        <videoPlay 
                            v-bind="item.options"
                            :poster='item.url'
                            @play="detailPlay"
                            @pause="detailPause"
                        />
                    </div>
                </div>
                <div v-if="item.type == 2">
                    <img class="goods-details-img" :src="item.url" alt="">
                </div>
                <div class="base-text" v-if="item.type == 1">
                    <span> {{ item.value }}</span>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import 'vue3-video-play/dist/style.css'
import { videoPlay } from 'vue3-video-play'
export default {
    // 商品详情
    name: 'BaseInfo',
    components: {
        videoPlay
    },
    props: {
        baseInfo: {
            type: Object,
            default: () => {},
            required: false
        }
    },
    data() {
        return {
            bindPlayCount: null,
            options: {
                width: '100%', //播放器高度
                height: '375px', //播放器高度
                color: "#409eff", //主题色
                title: '', //视频名称
                src: "", //视频源
                muted: false, //静音
                webFullScreen: false,
                speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
                autoPlay: true, //自动播放
                loop: false, //循环播放
                mirror: false, //镜像画面
                ligthOff: false,  //关灯模式
                volume: 0.3, //默认音量大小
                control: true, //是否显示控制器
            },
            detailObj: [],
            playIndex: null
        }
    },

    created() {
        let arr = this.baseInfo
        arr.forEach(item => {
            if(3 == item.type) {
                item.options = this.options,
                item.isPlay = false
            }
        })
        this.detailObj = this.baseInfo
    },

    methods: {
        videoPlayFun(index, id) {
            let arr = this.detailObj
            arr.forEach((item, i) => {
                if(i == index) {
                    item.isPlay = true
                } else {
                    item.isPlay = false
                }
            })
            this.$http.post('/base/media_play/' + id).then(({ data: res }) => {
                if(!res.success) {
                    this.$toast.fail(res.errorMessage);
                    return
                }
                arr[index].options.src = res.data
                arr[index].isPlay = true
                this.detailObj = arr
                this.playIndex = index
                this.$forceUpdate();
            })
            .catch((err) => console.log(err))
            .finally(()=>{this.$toast.clear()})
            
        },
        // 播放器停止播放
        detailPlay(ve) {
            this.$emit('detailPlay')
        },
        infonPlay(ve) {
            this.$emit('infoPlay')
        }
    },
    mounted() {

    },
}
</script>

<style>
    .base-info {
        width: 100%;
        height: 100%;
    }
    .details-title {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        padding: 12px 0 17px 16px;
        background: #fff;
        position: relative;
    }
    .details-title::after {
        content: '';
        width: 20px;
        height: 3px;
        background: #FF2560;
        border-radius: 2px;
        opacity: 1;
        position: absolute;
        left: 16px;
        bottom: 10px;
    }

    .goods-count {
        position: relative;
    }

    .goods-img {
        width: 100%;
        display: flex;
    }

    .video-plays {
        width: 100%;
        height: 375px;
    }
    .goods-details-img {
        width: 100%;
        display: flex;
    }

    .base-text {
        padding: 0 8px 16px 8px;
    }
</style>
